import qs from 'qs';
import client from '@/api/base';

// Children
import dashboard from './dashboard';

export default {
  async OASetupMember(data) {
    const response = await client.post('account/oa/org/', data);
    return response;
  },

  async getTeams(params) {
    const response = await client.get(`account/oa/org/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getSimpleTeams() {
    const response = await client.get('coaching/org/group/');
    return response;
  },

  async getTeamDetails(id) {
    const response = await client.get(`account/oa/org/${id}/`);
    return response;
  },

  async updateTeamDetails(id, data) {
    const response = await client.patch(`account/oa/org/${id}/`, data);
    return response;
  },

  async deleteTeam(id) {
    const response = await client.delete(`account/oa/org/${id}/`);
    return response;
  },

  async getTeamInvitation(teamId, params) {
    const response = await client.get(`account/oa/org/${teamId}/invite/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async deleteTeamInvitation(teamId, pk) {
    const response = await client.delete(`account/oa/org/${teamId}/invite/${pk}/`);
    return response;
  },

  async addTeamMember(teamId, data) {
    const response = await client.post(`account/oa/org/${teamId}/invite/`, data);
    return response;
  },

  async getLeaders(params) {
    const response = await client.get(`coaching/user/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getLeaderDetails(id) {
    const response = await client.get(`coaching/org/leader/${id}/`);
    return response;
  },

  async changeLeaderTeam(userId, teamId) {
    const response = await client.patch('coaching/org/group/leader/change/', {
      new_subgroup_uuid: teamId,
      user_uuid: userId,
    });
    return response;
  },

  async getSponsors(params) {
    const response = await client.get(`account/org/sponsor/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getSponsorDetails(id) {
    const response = await client.get(`account/org/sponsor/${id}`);
    return response;
  },

  async changeLeaderAvailability(userId) {
    const response = await client.patch(`coaching/org/leader/${userId}/change-status/`);
    return response;
  },

  async getOaLeaderInvoices(params) {
    const response = await client.get(`/account/org/leader/invoice/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getLeaderInvoiceDocOA(id) {
    const response = await client.get(`account/org/leader/invoice/${id}/`);
    return response;
  },

  async getCobrandingData() {
    const response = await client.get('account/oa/org/cobranding/');
    return response;
  },

  async patchCobrandingData(data) {
    const response = await client.patch('account/oa/org/cobranding/', data);
    return response;
  },

  ...dashboard,
};
